import { takeLatest, call, put } from 'redux-saga/effects'
import { startAction, stopAction } from '../loading/actions'
import { FETCH_AUTHENTICATED_USER_REQUEST, LOGIN_REQUEST, LOGOUT_REQUEST } from './actionTypes'
import { push } from 'connected-react-router'
import { fetchAuthenticatedUserSuccess, logoutSuccess, setInitRequest, setToken } from './actions'
import { LOGIN } from '../../routesConstants'
import authService from '../../supabaseServices/AuthService'
import { setLoader } from '../loader/actions'

export function* authorize() {
  try {
    yield put(setLoader(true))
    yield put(startAction('login'))
    // @ts-ignore
    const user = yield call(authService.getUserProfile)
    yield put(fetchAuthenticatedUserSuccess(user))
    yield put(setInitRequest(true))
    if (!user.role) throw new Error('Access Denied')
  } catch (error) {
    console.log(error)
  } finally {
    yield put(setLoader(false))
    yield put(stopAction('login'))
  }
}

export function* logout() {
  try {
    yield call(authService.onSignOut)
    yield setToken(null)
    yield put(logoutSuccess())
    yield put(push(LOGIN))
  } catch (error) {
    console.error(error)
  }
}

export function* fetchUser() {
  try {
    // @ts-ignore
    const user = yield call(authService.getUserProfile)
    yield put(fetchAuthenticatedUserSuccess(user))
  } catch (error) {
    console.log({ error })
  } finally {
  }
}

export default function* authSaga() {
  yield takeLatest(LOGIN_REQUEST, authorize)
  yield takeLatest(LOGOUT_REQUEST, logout)
  yield takeLatest(FETCH_AUTHENTICATED_USER_REQUEST, fetchUser)
}
